import React from 'react';
import Modal from './Modal';
import { AlertCircle } from 'lucide-react';

/**
 * Hold Expired Modal
 * Shown at 45 minutes (final expiration) with option to reload or browse
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is visible
 * @param {Function} props.onReload - Handler to reload the page
 * @param {Function} props.onBrowse - Handler to continue browsing (release hold)
 */
export default function HoldExpiredModal({
  isOpen,
  onReload,
  onBrowse
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onBrowse}
      title="Hold Expired"
      showCloseButton={false}
      closeOnEscape={false}
      closeOnBackdrop={false}
      footer={
        <>
          <button
            onClick={onBrowse}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition"
          >
            Continue Browsing
          </button>
          <button
            onClick={onReload}
            className="px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white rounded-lg transition font-semibold"
          >
            Try Again
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg">
          <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
          <div className="text-sm text-red-900 font-semibold">
            Your hold has expired
          </div>
        </div>

        <div className="text-gray-700">
          <p className="mb-3">
            We couldn&apos;t hold your selected date any longer, and it may now be available for other customers to book.
          </p>
          <p className="mb-3">
            You can try again to see if the date is still available, or continue browsing for other dates.
          </p>
          <p className="text-sm text-gray-600">
            <strong>Tip:</strong> Complete your booking within 20 minutes to secure your preferred date.
          </p>
        </div>
      </div>
    </Modal>
  );
}
